import './index.scss';
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { get } from '../../util/request';
import { useSelector } from 'react-redux';
import { userInfo } from '../../redux/slice';
import { useHistory } from 'react-router';
import ExitBanner from '../../components/page/exitBanner/index.js';
import Loading from '../../components/common/loading.js';

export default BankAccount; function BankAccount() {

    const history = useHistory();
    const { t } = useTranslation();
    const user = useSelector(userInfo);
    const [bankDetails, setBankDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const previewDetail = JSON.parse(sessionStorage.getItem('previewDetail'));


    const goto = (action, syndicationCurrency) => {
        history.push({
            pathname: user.sfUserType === 'IR' ? `/preview/bankAccountForm/${action}/${syndicationCurrency}` : `bankAccountForm/${action}/${syndicationCurrency}`
        });
    }

    useEffect(() => {
        if (user.sfUserType === 'CL' && history.location.pathname.includes('preview')) {
            history.push({
                pathname: '/bankAccount'
            });
        }
        else if (user.sfUserType === 'IR') {
            history.push({
                pathname: '/preview/bankAccount'
            });
        }

        bankList();
    }, []);

    const bankList = async () => {
        setLoading(true);
        let params = {
            accessToken: user.accessToken,
            userId: user.userId
        }
        const data = await get('/bankAccount/', params);
        setBankDetails(data);
        setLoading(false);
    };

    const maskAccountNumber = (data) => {
        return data.length > 4 ? '*'.repeat(data.length - 4) + data.slice(-4) : data;
    }

    return (
        ((user.sfUserType === 'CL' && user?.features?.filter(x => x.featureName === 'Bank Account Information')[0]?.isEnabled)
            || (user.sfUserType === 'IR' && previewDetail?.features?.filter(x => x.featureName === 'Bank Account Information')[0]?.isEnabled)) && <>
            {loading ? <Loading /> : null}
            <div className='bank-account'>
                <div className='main-box'>
                    <div className='row'>
                        <ExitBanner isMissingProfileBannerOpen={true} isUpdateProfileButtonVisible={true} />
                    </div>
                    <div className="headline bank-account-wrapper">
                        <div className='col-md-4 bank-account-title'><p>{t('Bank Account Information')}</p></div>
                        <div className='col-md-8 bank-account-header'></div>
                    </div>
                    <div className='submit-box bank-account-container row col-md-12'>
                        <div className='bank-account-div row col-md-6'>
                            {
                                bankDetails.filter(x => x.syndicationCurrency === 'USD').length > 0 ? (<>
                                    {
                                        bankDetails.filter(x => x.syndicationCurrency === 'USD').map((bank) => (<>
                                            <div className='bank-account-tiles'>
                                                <div className='col-md-12 row bank-account-details syndication-title'>
                                                    <p>{t('USD Distribution')}</p>
                                                </div>
                                                <div className='col-md-12 row bank-account-details'>
                                                    <div className='col-md-12'>
                                                        <span>{t('Bank Name')}</span>
                                                        <p>{bank.bankName}</p>
                                                    </div>
                                                </div>
                                                <div className='col-md-12 row bank-account-details'>
                                                    <div className='col-md-6'>
                                                        <span>{t('Account Number')}</span>
                                                        <p>{maskAccountNumber(bank.accountNumber)}</p>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <span>{t('Receiving Currency')}</span>
                                                        <p>{bank.accountCurrency}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='bank-account-button'>
                                                <button onClick={() => { goto('edit', 'usd') }}>{t('Edit')}</button>
                                            </div>
                                        </>))
                                    }

                                </>) : (<>
                                    <div className='bank-account-tiles'>
                                        <div className='col-md-12 row bank-account-details syndication-title'>
                                            <p>{t('USD Distribution')}</p>
                                        </div>
                                        <div className='col-md-12 row bank-account-details'>
                                            <div className='col-md-12'>
                                                <span>{t('Bank Name')}</span>
                                                <p>-</p>
                                            </div>
                                        </div>
                                        <div className='col-md-12 row bank-account-details'>
                                            <div className='col-md-6'>
                                                <span>{t('Account Number')}</span>
                                                <p>-</p>
                                            </div>
                                            <div className='col-md-6'>
                                                <span>{t('Receiving Currency')}</span>
                                                <p>-</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='bank-account-button'>
                                        <button onClick={() => { goto('add', 'usd') }}>{t('Create')}</button>
                                    </div>
                                </>)
                            }
                        </div>
                        <div className='bank-account-div row col-md-6'>
                            {
                                bankDetails.filter(x => x.syndicationCurrency === 'CAD').length > 0 ? (<>
                                    {
                                        bankDetails.filter(x => x.syndicationCurrency === 'CAD').map((bank) => (<>
                                            <div className='bank-account-tiles'>
                                                <div className='col-md-12 row bank-account-details syndication-title'>
                                                    <p>{t('CAD Distribution')}</p>
                                                </div>
                                                <div className='col-md-12 row bank-account-details'>
                                                    <div className='col-md-12'>
                                                        <span>{t('Bank Name')}</span>
                                                        <p>{bank.bankName}</p>
                                                    </div>
                                                </div>
                                                <div className='col-md-12 row bank-account-details'>
                                                    <div className='col-md-6'>
                                                        <span>{t('Account Number')}</span>
                                                        <p>{maskAccountNumber(bank.accountNumber)}</p>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <span>{t('Receiving Currency')}</span>
                                                        <p>{bank.accountCurrency}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='bank-account-button'>
                                                <button onClick={() => { goto('edit', 'cad') }}>{t('Edit')}</button>
                                            </div>
                                        </>))
                                    }

                                </>) : (<>
                                    <div className='bank-account-tiles'>
                                        <div className='col-md-12 row bank-account-details syndication-title'>
                                            <p>{t('CAD Distribution')}</p>
                                        </div>
                                        <div className='col-md-12 row bank-account-details'>
                                            <div className='col-md-12'>
                                                <span>{t('Bank Name')}</span>
                                                <p>-</p>
                                            </div>
                                        </div>
                                        <div className='col-md-12 row bank-account-details'>
                                            <div className='col-md-6'>
                                                <span>{t('Account Number')}</span>
                                                <p>-</p>
                                            </div>
                                            <div className='col-md-6'>
                                                <span>{t('Receiving Currency')}</span>
                                                <p>-</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='bank-account-button'>
                                        <button onClick={() => { goto('add', 'cad') }}>{t('Create')}</button>
                                    </div>
                                </>)
                            }
                        </div>
                    </div>
                    {
                        bankDetails.filter(x => x.phase !== null && x.phase !== '').length > 0 ? (<>
                            <div className='submit-box bank-account-container row col-md-12'>
                                {
                                    bankDetails.filter(x => x.phase !== null && x.phase !== '').map((bank) => (<>
                                        <div className='bank-account-div row col-md-6'>
                                            <div className='bank-account-tiles'>
                                                <div className='col-md-12 row bank-account-details syndication-title'>
                                                    <p>{bank.phase}</p>
                                                </div>
                                                <div className='col-md-12 row bank-account-details'>
                                                    <div className='col-md-12'>
                                                        <span>{t('Bank Name')}</span>
                                                        <p>{bank.bankName}</p>
                                                    </div>
                                                </div>
                                                <div className='col-md-12 row bank-account-details'>
                                                    <div className='col-md-6'>
                                                        <span>{t('Account Number')}</span>
                                                        <p>{maskAccountNumber(bank.accountNumber)}</p>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <span>{t('Receiving Currency')}</span>
                                                        <p>{bank.accountCurrency}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='bank-account-button'>
                                                <button onClick={() => { goto('view', bank.phase) }}>{t('View')}</button>
                                            </div>
                                        </div>
                                    </>))
                                }
                            </div>
                        </>) : null
                    }

                </div>
            </div>
        </>
    )
}